import React, { useState } from "react"
import { FeedItemContainer } from "./Feed.styles"
import FeedMediaType from "./FeedMediaType"

export default function FeedItem({ asset, feed }) {
  return <FeedItemContainer></FeedItemContainer>
}
